const TIMEOUT_MS = 15000
const OPTIONS = {
    enableHighAccuracy: true,
    maximumAge: 0,
    timeout: TIMEOUT_MS,
}

export const STATUS_ENUM = {
    CURRENT: 'CURRENT',
    LAST_KNOWN: 'LAST_KNOWN',
    NONE: 'NONE',
}

// See https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
const GEOLOCATION_POSITION_ERROR_MAP = {
    1: 'PERMISSION_DENIED',
    2: 'POSITION_UNAVAILABLE',
    3: 'TIMEOUT',
}

export const ERROR_NO_GEOLOCATION_CODE = 4

// Mimics GeolocationPositionError object
const ERROR_NO_GEOLOCATION = {
    code: ERROR_NO_GEOLOCATION_CODE,
    message: 'No geolocation object in navigator',
}

export const EXTENDED_GEOLOCATION_POSITION_ERROR_MAP = {
    ...GEOLOCATION_POSITION_ERROR_MAP,
    [ERROR_NO_GEOLOCATION_CODE]: 'NO_GEOLOCATION',
}

/*
    Turn getCurrentPosition() into a promise
    This function can now be used with 'await'
*/
export function getLocationFromNavigator() {
    return new Promise((resolve, reject) => {
        if ('geolocation' in navigator) {
            /*
                Resolves with GeolocationPosition object
                See https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPosition
                Rejects with GeolocationPositionError object
                See https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
            */
            navigator.geolocation.getCurrentPosition(
                resolve,
                reject,
                OPTIONS,
            );
        } else {
            reject(ERROR_NO_GEOLOCATION);
        }
    })
}
